import { LooseObject } from '@/pages/appstore/entities/app'

export enum UserRoleType {
    FrontlineStaff = 'frontline_staff',
    FrontlineManager = 'frontline_manager',
    HeadOffice = 'head_office'
}

export interface UserDetails {
    permissions: string[]
    company: LooseObject
    userRole: string
    userRoleType: UserRoleType
    hasPushDevice: number
}

export interface LoginToken {
    token: string,
    name: string,
    company: string
}

export interface MultiLoginTokens {
    [domain: string]: LoginToken
}

export interface MultiLoginTokenResult {
    success: boolean
    email?: string
    activationLinks?: MultiLoginTokens,
    msg?: string
}

export interface GoogleAuthResult {
    id: string,
    name: string,
    familyName: string,
    givenName: string,
    imageUrl: string
    email: string,
    serverAuthCode: string,

    authentication: {
        accessToken: string,
        refreshToken: string,
        idToken: string
    }
}

export interface GoogleSignInResult {
    success: boolean
    data?: GoogleAuthResult
    msg?: string
}
